'use strict';

module.exports = ApplicationLoggerProvider;

/**
 * Application Logging Service to give us a way of logging
 * error / debug statements from the client to the server.
 *
 * TODO: Should consider overriding $log to inject this behavior with a flag so that it only uploads on demand. Investigate AngularJS's interceptor support to accomplish this
 */
function ApplicationLoggerProvider() {
  var pr_fbURL = '';

  this.firebaseURL = function (fbURL) {
    if (typeof fbURL === 'undefined') {
      return pr_fbURL;
    }
    pr_fbURL = fbURL;
  };

  this.$get = [
    '$log',
    '$window',
    'APP_ENV',
    function ($log, $window, APP_ENV) {
      var loggerRef;

      //try {
      //  loggerRef = new $window.Firebase(pr_fbURL + '/logger/messages');
      //} catch (loggingError) {
      //  $log.warn('Error fetching Firebase: ' + pr_fbURL);
      //  $log.log(loggingError);
      //}

      function log(data) {
        if (typeof loggerRef !== 'undefined') {
          loggerRef.push(data);
        }
      }

      return {

        error: function (message, error) {
          // preserve default behaviour
          $log.error.apply($log, arguments);
          // send server side
          log({
            clientVersion: APP_ENV.CLIENT_VERSION,
            url: $window.location.href,
            message: message,
            error: error || null,
            type: 'error',
            dateCreated: new Date().getTime()
          });
        },

        debug: function (message, error) {
          $log.log.apply($log, arguments);
          log({
            clientVersion: APP_ENV.CLIENT_VERSION,
            url: $window.location.href,
            message: message,
            error: error || null,
            type: 'debug',
            dateCreated: new Date().getTime()
          });
        }
      };
    }]
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/firebaseLogger/ApplicationLogger.js